import React, { useEffect } from 'react'
import { signoutRedirectCallback } from 'services/userService'
import { useHistory } from 'react-router-dom'

function SignoutOidc() {
  const history = useNavigate()
  useEffect(() => {
    async function signoutAsync() {
      await signoutRedirectCallback()
      history('/')
    }
    signoutAsync()
  }, [history])

  return (
    <div>
      Redirecting...
    </div>
  )
}

export default SignoutOidc
